var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Block',{attrs:{"type":"text","icon":"block-text","id":_vm.id,"collections":_vm.collections,"show-controls":_vm.showControls,"searchable":_vm.searchable}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$markdown(_vm.synopsis))}})])}
var staticRenderFns = []

export { render, staticRenderFns }